
export {
    Form,
    FormSet,
    ManagementForm,
    Widget,
    useForm,
    useFormSet,
} from "reactivated/dist/forms";

import type {_Types} from "./index";
import * as forms from "reactivated/dist/forms";

import {Context} from "./context";
export const CSRFToken = forms.createCSRFToken(Context);

export const {createRenderer, Iterator} = forms.bindWidgetType<_Types["globals"]["Widget"]>();
export type FieldHandler = forms.FieldHandler<_Types["globals"]["Widget"]>;
export type {FormHandler} from "reactivated/dist/forms";
